import { useSelector } from 'react-redux';
import ProjectsList from './ProjectsList';

const Main = () => {
  const projectsList = useSelector(({ projects }) => projects.list);

  return <ProjectsList allProjects={projectsList} />;
};

export default Main;
